<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">
              Temporary Links
            </h4>
            <button data-toggle="modal" @click="fixModal" data-target="#newLinkModal" class="btn btn-outline-primary pull-right"> Add New Custom Link</button>
          </div>
          <div class="card-body">
            <div class="loader" v-if="loading"></div>
            <table class="table table-striped table-bordered job-announcement-datatable" v-else>
              <thead>
              <tr>
                <th>Live Domain</th>
                <th class="text-center">Temp Domain</th>
                <th class="text-center">IP</th>
                <th class="text-center">Remaining Time</th>
                <th class="text-center">Created By</th>
                <th class="text-center">Created At</th>
                <th class="text-center">Action
                  <i title="Please use fix button if temporary link is not working." data-toggle="tooltip" data-placement="top" data-html="true" class="fa fa-info-circle mr-4 make-cursor-pointer"></i>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(link, index) in tempLinks" :key="link.id">
                <td>
                  {{link.liveDomain}}
                  <a href="#" @click.prevent="doCopy(link.liveDomain)"><i class="fa fa-copy"></i></a>
                </td>
                <td class="text-center">
                  {{link.tempDomain}}
                  <a href="#" @click.prevent="doCopy(link.tempDomain)"><i class="fa fa-copy"></i></a>
                </td>
                <td width="15%" class="text-center">
                  {{link.ip}}
                  <a href="#" @click.prevent="doCopy(link.ip)"><i class="fa fa-copy"></i></a>
                </td>
                <td width="15%" class="text-center">
                  {{getExpiryTime(link)}}
                </td>
                <td class="text-center">
                  {{link.createdBy}}
                </td>
                <td class="text-center">
                  {{link.createdAt | formatDate }}
                </td>
                <td width="10%" class="text-center">
                  <button class="btn btn-sm btn-outline-primary mr-4" @click="fixTempLink(link, index)">
                    <div v-if="fixLoader" class="loader" style="width: 15px;height: 15px; margin: 0 !important;"></div>
                    <span v-else>Fix</span>
                  </button>
                  <button class="btn btn-sm btn-outline-danger" @click="removeTemp(link)">
                    <div v-if="deleting" class="loader" style="width: 15px;height: 15px; margin: 0 !important;"></div>
                    <i v-else class="fa fa-times"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="new-announcement-modal position-relative">
        <div class="modal fade newAnnouncementModal" id="newLinkModal" tabindex="-1" role="dialog" aria-labelledby="newAnnouncementModal" aria-hidden="true">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <form @submit.prevent="submitLink">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Add new Custom Link</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                    <label>Domain</label>
                    <input type="text" v-model="newLink.domain" class="form-control">
                  </div>
                  <div class="form-group">
                    <label>IP</label>
                    <input type="text" v-model="newLink.ip" class="form-control">
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <label>Expiry Time</label>
                      </div>
                      <div class="col-md-4">
                        <select class="form-control" v-model="newLink.expiryTime">
                          <option value="10">10 minutes</option>
                          <option value="30">30 minutes</option>
                          <option value="60">1 hour</option>
                          <option value="1440">24 hours</option>
                          <option value="permanent">Permanent</option>
                          <option value="custom">Custom</option>
                        </select>
                      </div>
                      <div class="col-md-4" v-if="newLink.expiryTime === 'custom'">
                        <input type="number" required v-model="newLink.value" class="form-control">
                      </div>
                      <div class="col-md-4" v-if="newLink.expiryTime === 'custom'">
                        <select class="form-control" v-model="newLink.unit">
                          <option value="hours">Hours</option>
                          <option value="days">Days</option>
                          <option value="minutes">Minutes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="submit" class="btn btn-primary" :disabled="adding || !newLink.domain || !newLink.ip">
                    <div class="loader small_loader" v-if="adding"></div>
                    <span v-else>Submit</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import swal from 'sweetalert2';
import moment from "moment";
export default {
  name: "TemporaryLinks",
  data() {
    return {
      tempLinks: [],
      loading: true,
      deleting: false,
      adding: false,
      newLink: {
        expiryTime: '30',
        value: 5,
        unit: 'hours',
      },
      fixLoader: false,
      selectedIndex: -1,
      times: {
        '10': '10 Minutes',
        '30': '30 Minutes',
        '60': '1 Hour',
        '1440': '24 Hour',
        'permanent': 'Permanent',
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  mounted () {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
    this.getTempLinks();
  },
  methods: {
    getExpiryTime (link) {
      if (link.expiryTime) {
        if (link.expiryTime === 'permanent') {
          return `Permanent`
        } else {
          return moment(link.expiryDate).local().fromNow().replace('in', '')
        }
      }
    },
    doCopy(item){
      this.$copyText(item).then(() => {
        this.$notify({
          group: 'foo',
          title: 'Message',
          text: 'Copied!'
        });
      }, function (e) {
        console.log(e)
      });
    },
    fixModal() {
      /* eslint-disable */
      $(document).ready(function() {
        $(".modal-backdrop").appendTo(".new-announcement-modal");
      });
      /* eslint-enable */
    },
    getTempLinks () {
      this.tempLinks = [];
      $(".job-announcement-datatable").DataTable().destroy();
      const announcementQuery = db.collection('temp-domains').orderBy('createdAt', "desc");
      announcementQuery.get().then(docs => {
        let ann = [];
        docs.forEach(doc => {
          ann.push({id: doc.id, ...doc.data()});
        });
        this.tempLinks = ann;
      }).finally(() => {
        this.loading = false;
        this.initDataTable();
      })

    },
    initDataTable () {
      /* eslint-disable */
      $(document).ready(function () {
        $(".job-announcement-datatable").DataTable({
          ordering: false,
          retrieve: true,
          language: {
            search: "_INPUT_",
            searchPlaceholder: "Search",
            emptyTable: "No link exist in the system",
            size: '40'
          }
        });
        $('#newAnnouncementModal').modal('hide');
      });
      /* eslint-enable */
    },
    async removeTemp(data){
      try {
        this.deleting = true
        try {
          await this.$http.post('utilities/remove_temp_link', {
            grant_type: 'token',
            docId: data.id,
            domain: data.liveDomain,
          });
          this.getTempLinks()
          this.result = null
          swal({
            title: "Success",
            text: 'Successfully deleted this temp domain!',
            type: "success",
          });
        } catch (e) {
          console.log(e)
          swal({
            title: "Error",
            text: 'Error in deleting this temp domain!',
            type: "error",
          });
        }
        this.deleting = false
      } catch (e) {
        console.log(e)
      }
    },
    async fixTempLink(data, index){
      try {
        this.fixLoader = true;
        this.selectedIndex = index;
        try {
          const response = await this.$http.post('utilities/fix_temp_link', {
            grant_type: 'token',
            domain: data.liveDomain,
          });
          if(response.data.status === 'pass') {
            swal({
              title: "Success",
              text: 'Temporary link has been fixed successfully!',
              type: "success",
            });
          }
        } catch (e) {
          console.log(e)
          swal({
            title: "Error",
            text: 'Error in fixing temporary link!',
            type: "error",
          });
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.selectedIndex = -1
        this.fixLoader = false
      }
    },
    async submitLink () {
      try {
        this.adding = true
        const resp = await this.$http.post('utilities/create_temp_link', {
          grant_type: 'token',
          domain: this.newLink.domain,
          ip: this.newLink.ip,
          createdBy: this.user.firstName + ' ' + this.user.lastName,
          expiryTime: this.newLink.expiryTime,
          value: this.newLink.value,
          unit: this.newLink.unit,
        });
        this.getTempLinks()
        this.newLink = {
          expiryTime: '30',
          value: 5,
          unit: 'hours',
        }
        swal({
          title: "Success",
          text: resp.data.message,
          type: "success",
        });
        $('#newLinkModal').modal('hide');
      } catch (e) {
        console.log(e)
      }
      this.adding = false
    }
  }
}
</script>

<style scoped>

</style>
